/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIMeasurementRequest } from './APIMeasurementRequest';
import {
    APIMeasurementRequestFromJSON,
    APIMeasurementRequestFromJSONTyped,
    APIMeasurementRequestToJSON,
} from './APIMeasurementRequest';
import type { APIHumanReadableDurationRequest } from './APIHumanReadableDurationRequest';
import {
    APIHumanReadableDurationRequestFromJSON,
    APIHumanReadableDurationRequestFromJSONTyped,
    APIHumanReadableDurationRequestToJSON,
} from './APIHumanReadableDurationRequest';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedArticleRequest
 */
export interface APIPatchedArticleRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedArticleRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedArticleRequest
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedArticleRequest
     */
    hoopsPartId?: string;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPatchedArticleRequest
     */
    weight?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPatchedArticleRequest
     */
    length?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPatchedArticleRequest
     */
    width?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPatchedArticleRequest
     */
    height?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPatchedArticleRequest
     */
    volume?: APIMeasurementRequest | null;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedArticleRequest
     */
    barcodeText?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedArticleRequest
     */
    qualityClass?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedArticleRequest
     */
    countryOfOrigin?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedArticleRequest
     */
    description?: string;
    /**
     * 
     * @type {APIHumanReadableDurationRequest}
     * @memberof APIPatchedArticleRequest
     */
    leadTime?: APIHumanReadableDurationRequest | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIPatchedArticleRequest
     */
    isBomBase?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIPatchedArticleRequest
     */
    isImportedVersion?: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedArticleRequest
     */
    articleType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedArticleRequest
     */
    family?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedArticleRequest
     */
    brand?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedArticleRequest
     */
    barcodeType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedArticleRequest
     */
    material?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedArticleRequest
     */
    variationOf?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedArticleRequest
     */
    supplier?: string | null;
    /**
     * 
     * @type {Array<string | null>}
     * @memberof APIPatchedArticleRequest
     */
    category?: Array<string | null>;
    /**
     * 
     * @type {Array<string | null>}
     * @memberof APIPatchedArticleRequest
     */
    properties?: Array<string | null>;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedArticleRequest
     */
    guestRequest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedArticleRequest
     */
    sharedRequest?: string | null;
}

/**
 * Check if a given object implements the APIPatchedArticleRequest interface.
 */
export function instanceOfAPIPatchedArticleRequest(value: object): value is APIPatchedArticleRequest {
    return true;
}

export function APIPatchedArticleRequestFromJSON(json: any): APIPatchedArticleRequest {
    return APIPatchedArticleRequestFromJSONTyped(json, false);
}

export function APIPatchedArticleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedArticleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'number': json['number'] == null ? undefined : json['number'],
        'hoopsPartId': json['hoops_part_id'] == null ? undefined : json['hoops_part_id'],
        'weight': json['weight'] == null ? undefined : APIMeasurementRequestFromJSON(json['weight']),
        'length': json['length'] == null ? undefined : APIMeasurementRequestFromJSON(json['length']),
        'width': json['width'] == null ? undefined : APIMeasurementRequestFromJSON(json['width']),
        'height': json['height'] == null ? undefined : APIMeasurementRequestFromJSON(json['height']),
        'volume': json['volume'] == null ? undefined : APIMeasurementRequestFromJSON(json['volume']),
        'barcodeText': json['barcode_text'] == null ? undefined : json['barcode_text'],
        'qualityClass': json['quality_class'] == null ? undefined : json['quality_class'],
        'countryOfOrigin': json['country_of_origin'] == null ? undefined : json['country_of_origin'],
        'description': json['description'] == null ? undefined : json['description'],
        'leadTime': json['lead_time'] == null ? undefined : APIHumanReadableDurationRequestFromJSON(json['lead_time']),
        'isBomBase': json['is_bom_base'] == null ? undefined : json['is_bom_base'],
        'isImportedVersion': json['is_imported_version'] == null ? undefined : json['is_imported_version'],
        'articleType': json['article_type'] == null ? undefined : json['article_type'],
        'family': json['family'] == null ? undefined : json['family'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'barcodeType': json['barcode_type'] == null ? undefined : json['barcode_type'],
        'material': json['material'] == null ? undefined : json['material'],
        'variationOf': json['variation_of'] == null ? undefined : json['variation_of'],
        'supplier': json['supplier'] == null ? undefined : json['supplier'],
        'category': json['category'] == null ? undefined : json['category'],
        'properties': json['properties'] == null ? undefined : json['properties'],
        'guestRequest': json['guest_request'] == null ? undefined : json['guest_request'],
        'sharedRequest': json['shared_request'] == null ? undefined : json['shared_request'],
    };
}

export function APIPatchedArticleRequestToJSON(value?: APIPatchedArticleRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'number': value['number'],
        'hoops_part_id': value['hoopsPartId'],
        'weight': APIMeasurementRequestToJSON(value['weight']),
        'length': APIMeasurementRequestToJSON(value['length']),
        'width': APIMeasurementRequestToJSON(value['width']),
        'height': APIMeasurementRequestToJSON(value['height']),
        'volume': APIMeasurementRequestToJSON(value['volume']),
        'barcode_text': value['barcodeText'],
        'quality_class': value['qualityClass'],
        'country_of_origin': value['countryOfOrigin'],
        'description': value['description'],
        'lead_time': APIHumanReadableDurationRequestToJSON(value['leadTime']),
        'is_bom_base': value['isBomBase'],
        'is_imported_version': value['isImportedVersion'],
        'article_type': value['articleType'],
        'family': value['family'],
        'brand': value['brand'],
        'barcode_type': value['barcodeType'],
        'material': value['material'],
        'variation_of': value['variationOf'],
        'supplier': value['supplier'],
        'category': value['category'],
        'properties': value['properties'],
        'guest_request': value['guestRequest'],
        'shared_request': value['sharedRequest'],
    };
}

